module.exports = __webpack_public_path__ + "static/media/superai_symbol_sm.b3509ef5.png";